<template>
  <a :href="url" target="_blank">
    <div class="map-container" :style="{ background: getSecondaryColor() }">
      <img class="map-img" src="../../assets/images/map_img.png" width="135px" height="79px" alt="map image" />
      <span class="text">Search on map instead</span>
      <font-awesome-icon style="color: white" :icon="['fas', 'arrow-right']" />
    </div>
  </a>
</template>

<script>
export default {
  name: "SearchOnMapInstead",
  props: { type: String, search: String },
  data() {
    return { url: "" }
  },
  watch: {
    type(newVal, oldVal) {
      this.changeUrl(newVal, this.search)
    },
    search(newVal, oldVal) {
      this.changeUrl(this.type, newVal)
    },
  },
  mounted() {
    this.url = process.env.SSO_BASE_URL
    this.changeUrl(this.type, this.search)
  },
  methods: {
    changeUrl(type, search) {
      const t = type ? `&item_type=${type.replace(/ /g, "+")}` : ""
      const s = search ? `&search_name=${search.replace(/ /g, "+")}` : ""
      const previous = `?previous=${encodeURIComponent(window.location.href)}&appName=${encodeURIComponent("MyCircles")}`
      this.url = `${process.env.SSO_BASE_URL}/dovemap/${previous}` + t + s
    },
  },
}
</script>

<style lang="scss" scoped>
.map-container {
  display: flex;
  gap: 16px;
  background: #062b54;
  border-radius: 8px;
  padding: 16px 24px;
  align-items: center;
  cursor: pointer;
  .map-img {
    @media only screen and (max-width: 700px) {
      width: 93.99px;
      height: 55px;
    }
  }
  .text {
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    color: #ffffff;
    flex: 1;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/SearchOnMapComponent.vue